import {User} from 'common/typings';

export function isUserSignIn(user?: User) {
    return Boolean(user && (user.uid || user.isFederationUser));
}
